import React, { createContext, useCallback, useContext } from "react";
import { notification } from "antd";
import { useTranslation } from "react-i18next";
import { fleetToastContent } from "../utils/fleetFeedback";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const { t } = useTranslation();
  const [api, contextHolder] = notification.useNotification({
    placement: "bottomRight",
  });

  const toast = useCallback(({ title, description, status, error, reference, duration }) => {
    const typeMap = {
      success: "success",
      warning: "warning",
      error: "error",
      info: "info",
    };

    api.open({
      ...fleetToastContent(t, { title, description, error, reference }),
      type: typeMap[status] || "info",
      duration: duration == null ? (status === "success" ? 5 : 9) : duration / 1000,
    });
  }, [api, t]);

  return (
    <ToastContext.Provider value={toast}>
      {contextHolder}
      {children}
    </ToastContext.Provider>
  );
};

export const useGlobalToast = () => useContext(ToastContext);
